<div class="side-padding my-3">
  <h4 class="font-weight-bolder">Survey Submitted!</h4>
  <p>Thank you for taking your time to answer our survey.</p>
</div>